module.exports = __webpack_public_path__ + "static/media/bannerDrawerMobile.cc321297.svg";